import {Component, inject, OnInit} from '@angular/core';
import {NewsService} from "../../services/news.service";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {News} from "../../models/news";
import {first, Subscription} from "rxjs";
import {DatePipe, isPlatformBrowser} from "@angular/common";
import {ImageBase64ContentPipe} from "../../../core/pipes/image-base64-content.pipe";
import {MatPaginator, MatPaginatorIntl, PageEvent} from "@angular/material/paginator";
import {CustomPaginatorIntl} from "../../../core/material/custom-paginator-intl";
import {PageBase} from "../../../core/components/page-base";
import {getTranslation} from "../../../core/models/translatable-model-abstract";
import {NewsListWrapper} from "../../models/news-list-wrapper";

@Component({
  selector: 'app-news-list',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    ImageBase64ContentPipe,
    MatPaginator,
  ],
  providers: [{provide: MatPaginatorIntl, useClass: CustomPaginatorIntl}],
  templateUrl: './news-list.component.html',
  styleUrl: './news-list.component.scss'
})
export class NewsListComponent extends PageBase {
  private newsService = inject(NewsService);
  private activatedRoute = inject(ActivatedRoute);

  protected page: number = 1;
  protected paginatorTotalItemsCount: number = 0;
  protected newsListWrapper: NewsListWrapper | null = null;
  protected activatedRouteSubscription: Subscription | null = null;

  constructor() {
    super();
  }

  handlePaginatorChangeEvent(e: PageEvent) {
    let newPage = e.pageIndex + 1;
    this.router.navigate([`/news-list/${newPage}`]);
  }

  override ngOnInit(): void {
    this.pageTitle = "Новини за бързи кредити - Minizaem.bg";
    this.metaDescription = "Новини за бързи кредити.";
    super.ngOnInit();

    this.activatedRouteSubscription = this.activatedRoute.params.subscribe(params => {
      this.page = params['page'] ?? 1;

      // 3. Fallback to API if it's the server rendering it, OR on future client navigation
      this.newsService.getListFromApi(this.page).subscribe({
        next: newsListRes => {
          this.newsListWrapper = newsListRes;
          this.paginatorTotalItemsCount = this.newsListWrapper.paginatorData?.totalItemCount;
        },
      });
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.activatedRouteSubscription) {
      this.activatedRouteSubscription?.unsubscribe();
    }
  }

  protected readonly getTranslation = getTranslation;
}
